module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', [_c('ValueCardGroup', {
    attrs: {
      "data": _vm.base_data
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('ValueCardGroup', {
    attrs: {
      "data": _vm.slide_data
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    on: {
      "change": _vm.getChartData
    },
    model: {
      value: (_vm.selected_year),
      callback: function($$v) {
        _vm.selected_year = $$v
      },
      expression: "selected_year"
    }
  }, _vm._l((_vm.limite_data), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item,
        "value": item
      }
    })
  })), _vm._v(" "), _vm._l((_vm.charts), function(item) {
    return [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('SingleChart', {
      attrs: {
        "title": item.title,
        "chart_type": item.type,
        "x_name": item.x_name,
        "y_name": item.y_name,
        "x_axis": item.x_data,
        "x_data": item.y_data,
        "is_loading": _vm.chart_loading,
        "more_info": item.more_info
      }
    })], 1)]
  })], 2), _vm._v(" "), _c('HomeBody', {
    attrs: {
      "table_list": _vm.tables
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2a3eeb2c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 252
// module chunks = 2